import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Wand2 } from "lucide-react";
import { LOGO_URL } from "@/data/catalog";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/customizer", label: "Create Your Own Wrap", testid: "tab-customizer", highlight: true },
  { to: "/tint", label: "Tint Lab", testid: "tab-tint", highlight: true },
  { to: "/book", label: "Book Now", testid: "tab-book", highlight: true },
  { to: "/decals", label: "Custom Decals", testid: "tab-decals" },
  { to: "/contact", label: "Contact & Quote", testid: "tab-contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0B0E]/85 border-b border-edge/80"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 shrink-0" onClick={() => setOpen(false)}>
          <span className="relative inline-flex">
            <img
              src={LOGO_URL}
              alt="G5 Auto Restyling logo"
              className="h-11 w-11 rounded-full object-cover ring-2 ring-velocity/80 shadow-[0_0_18px_rgba(255,42,59,0.45)]"
            />
          </span>
          <span className="leading-none">
            <span className="block font-display font-black text-lg tracking-tight uppercase">G5 Auto</span>
            <span className="block font-mono text-[10px] tracking-[0.3em] text-steel uppercase">Restyling Studio</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
                  l.highlight
                    ? isActive
                      ? "bg-velocity text-white"
                      : "text-velocity hover:bg-velocity/10 border border-velocity/40"
                    : isActive
                      ? "text-white bg-raise"
                      : "text-slate-400 hover:text-white hover:bg-raise/60"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/customizer"
            data-testid="nav-start-customizer-btn"
            className="inline-flex items-center gap-2 bg-velocity hover:bg-velocitydark text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200 shadow-[0_0_20px_rgba(255,42,59,0.35)]"
          >
            <Wand2 className="h-4 w-4" />
            Start Custom Wrap
          </Link>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden text-slate-200 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-edge bg-[#0A0B0E]/95 backdrop-blur-xl px-4 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className={`block px-4 py-3 rounded-lg text-sm font-medium ${
                location.pathname === l.to
                  ? "bg-raise text-white"
                  : l.highlight
                    ? "text-velocity"
                    : "text-slate-400 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
